import React from "react";
import { FaStar } from "react-icons/fa";
import "./HomeReviews.css";

const PREVIEW_REVIEWS = [
  {
    quote:
      "Flawless execution from planning to the last detail. Our corporate event in Gujarat looked premium and ran on time—highly recommend Panthi Events as a corporate event organizer.",
    author: "Priya S.",
    role: "Corporate client",
  },
  {
    quote:
      "They understood our vision for the wedding and delivered beyond expectations as our wedding planner in Ahmedabad—calm, professional, and truly passionate about what they do.",
    author: "Rahul & Meera",
    role: "Wedding",
  },
  {
    quote:
      "Transparent communication and strong on-ground coordination for our family celebration. We could actually enjoy the event while Panthi Events handled everything seamlessly.",
    author: "Vikram K.",
    role: "Social celebration",
  },
];

const HomeReviews = () => {
  return (
    <section id="reviews" className="home-reviews">
      <div className="home-reviews-container">
        <div className="section-header">
          <h2 className="section-title">Client Reviews</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle home-reviews-subtitle">
            Real feedback from people who trusted us with their celebrations and
            events
          </p>
        </div>

        <div className="home-reviews-grid">
          {PREVIEW_REVIEWS.map((item, index) => (
            <blockquote key={index} className="home-review-card">
              <div className="home-review-stars" aria-label="5 out of 5 stars">
                {[1, 2, 3, 4, 5].map((s) => (
                  <FaStar key={s} className="home-review-star" />
                ))}
              </div>
              <p className="home-review-quote">&ldquo;{item.quote}&rdquo;</p>
              <footer className="home-review-meta">
                <cite className="home-review-author">{item.author}</cite>
                <span className="home-review-role">{item.role}</span>
              </footer>
            </blockquote>
          ))}
        </div>

        {/* <div className="home-reviews-footer">
          <p className="home-reviews-note">
            Many of our reviews also appear on Google. We&apos;re grateful for
            every client who takes a moment to share their experience.
          </p>
          <Link to="/reviews" className="btn btn-primary home-reviews-cta">
            View all reviews
          </Link>
        </div> */}
      </div>
    </section>
  );
};

export default HomeReviews;
